import { getLocalStoragePreferences } from 'src/App/utils'
import useStoreSelector from 'utils/hooks/useStoreSelector'
import {
  DETAIL_TABLE_ITEMS_PER_PAGE,
  GENERAL_CONFIG,
  MAIN_SECTION_ID,
  TABLE_ITEMS_PER_PAGE,
  detailsType,
  LAZY_LOADED_TYPES
} from '../constants'

const { GRID, SERVER_GRID } = detailsType

export const autosizeOrFitColumnsToWidth = ({ columnApi, api }) => {
  const headerWrap = getLocalStoragePreferences('headerWrap')
  autosizeOrFitColumnsToWidthUtil(columnApi, api, headerWrap)

  setTimeout(() => {
    autosizeOrFitColumnsToWidthUtil(columnApi, api, headerWrap)
  }, 600)
}

const autosizeOrFitColumnsToWidthUtil = (columnApi, api, headerWrap) => {
  const colIds = columnApi.getAllColumns().map(({ colId }) => colId)
  columnApi.autoSizeColumns(colIds, headerWrap)

  const { eBodyViewport, columnController } = api.gridPanel
  const availableWidth = eBodyViewport.clientWidth
  const columns = columnController.getAllDisplayedColumns()
  const usedWidth = columnController.getWidthOfColsInList(columns)

  if (usedWidth < availableWidth) {
    api.sizeColumnsToFit()
  }

  columnApi.autoSizeColumns([colIds[0]], headerWrap)
}

const getDetailGridRowHeight = ({ api, data }) => {
  const detailGrid = api?.getDetailGridInfo(data.id)
  // The detail grid is registered with a bit of delay
  if (detailGrid) {
    return detailGrid.domElement.offsetHeight
  }
  return 0
}

const rowHeightByDetailType = {
  [detailsType.GRID]: getDetailGridRowHeight,
  [detailsType.SERVER_GRID]: getDetailGridRowHeight
  // map: () => 400 // Just an example
}

export const getRowHeight = (params) => {
  // Ignore rows that are not details
  if (!params.node.detail) return undefined

  const heigth = params.data.fields.reduce((acc, field) => {
    const heightCalculator = rowHeightByDetailType[field.type]
    return acc + heightCalculator(params)
  }, 0)
  //if i'm in the document but the detail is open on the input view, 0 will 'close' the accordion but the > is not coherent
  return heigth === 0 ? undefined : heigth
}

export const isMainSection = (section) => section.title === MAIN_SECTION_ID

export const refreshAllColumnFilters = ({ api, columnApi }) => {
  const setFilterColumns = columnApi
    .getAllColumns()
    .filter(({ colDef }) => colDef.filter === 'agSetColumnFilter')

  for (const { colId } of setFilterColumns) {
    const filter = api.getFilterInstance(colId) // This method has a side effect: it fetches the filter's options if they were never fetched

    // Here we refetch options only if they were already fetched.
    // If the promise status is 0, it means options were never fetched,
    // so we let 'getFilterInstance' side effect fetch them to avoid 2 network calls
    if (filter.getValueModel().allValuesPromise?.status !== 0) {
      filter.refreshFilterValues()
    }
  }
}

export const getGeneralModelConfig = (models) => {
  const {
    itemsPerPage = TABLE_ITEMS_PER_PAGE,
    detailItemsPerPage = DETAIL_TABLE_ITEMS_PER_PAGE,
    ...rest
  } = models[GENERAL_CONFIG] || {}

  return { itemsPerPage, detailItemsPerPage, ...rest }
}

export const setGridPagination = (gridApi, blockSize, serverSideDataSource) => {
  if (serverSideDataSource) {
    gridApi.gridOptionsWrapper.setProperty('cacheBlockSize', blockSize)
    gridApi.setServerSideDatasource(serverSideDataSource)
  }
  gridApi.paginationSetPageSize(blockSize)
}

export const isGrid = ({ type }) => [GRID, SERVER_GRID].includes(type)

export const isLazyLoaded = ({ type }) => LAZY_LOADED_TYPES.includes(type)

export const isDetail = isGrid

export const getOptionTranslation = (t, key) => {
  const defaultValue = t(`OptionsPlatform:${key}`)
  return defaultValue === key ? t(`Options:${key}`) : defaultValue
}
